import React, { useState } from 'react';
import { X, Play } from 'lucide-react';

const Portfolio = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const portfolioItems = [
    {
      title: "Inside Keowee Key's All-Inclusive Lifestyle",
      videoId: 'eWYjzsIWalE',
      category: 'Horizontal',
      thumbnail: 'https://img.youtube.com/vi/eWYjzsIWalE/maxresdefault.jpg',
      isYouTube: true
    },
    {
      title: 'Cross Creek Local Spotlight',
      videoId: 'y3eL9p994pI',
      category: 'Horizontal',
      thumbnail: 'https://img.youtube.com/vi/y3eL9p994pI/maxresdefault.jpg',
      isYouTube: true
    },
    {
      title: 'Keowee Key Annual Golf Tournament',
      videoId: 'zq55AzxtFvA',
      category: 'Horizontal',
      thumbnail: 'https://img.youtube.com/vi/zq55AzxtFvA/maxresdefault.jpg',
      isYouTube: true
    },
    {
      title: 'HD Tour with Agent',
      videoId: '1AiZd9k2Tr9wT0ZtyUgVLK-TeDo7Jv94h',
      category: 'Horizontal',
      thumbnail: 'https://drive.google.com/thumbnail?id=1AiZd9k2Tr9wT0ZtyUgVLK-TeDo7Jv94h&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Cinematic HD Tour',
      videoId: '1HWawGWHFGt8cIa7D4SQqOXxnrpAzuFmb',
      category: 'Horizontal',
      thumbnail: 'https://drive.google.com/thumbnail?id=1HWawGWHFGt8cIa7D4SQqOXxnrpAzuFmb&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Real Estate Promotion Video',
      videoId: '1rRwZQNpRvox-2GDAyBBoc1BZbuzXy3mK',
      category: 'Horizontal',
      thumbnail: 'https://drive.google.com/thumbnail?id=1rRwZQNpRvox-2GDAyBBoc1BZbuzXy3mK&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Vertical Reel Tour',
      videoId: '1g_0-UA2m4XQ7YXbwteXMjJ7hnz5Bq05i',
      category: 'Vertical',
      thumbnail: 'https://drive.google.com/thumbnail?id=1g_0-UA2m4XQ7YXbwteXMjJ7hnz5Bq05i&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Short-Form Content',
      videoId: '1Sb6hurWQ_LNmS_oRWLUr3a_nsyhzRQEC',
      category: 'Vertical',
      thumbnail: 'https://drive.google.com/thumbnail?id=1Sb6hurWQ_LNmS_oRWLUr3a_nsyhzRQEC&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Austin Mauldin Experience',
      videoId: '1sVnHv7kzKDZXEbVdsC4T8Dku0UG6DkVl',
      category: 'Vertical',
      thumbnail: 'https://drive.google.com/thumbnail?id=1sVnHv7kzKDZXEbVdsC4T8Dku0UG6DkVl&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Agent Vertical Reel',
      videoId: '1CRSeb0DL3S2aLHn6h0SQ0VICfyHnAg6Z',
      category: 'Vertical',
      thumbnail: 'https://drive.google.com/thumbnail?id=1CRSeb0DL3S2aLHn6h0SQ0VICfyHnAg6Z&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Drone Video Vertical',
      videoId: '1xsQg_8RNOIDALF1GzuJO7IgK5l7VZZg0',
      category: 'Vertical',
      thumbnail: 'https://drive.google.com/thumbnail?id=1xsQg_8RNOIDALF1GzuJO7IgK5l7VZZg0&sz=w1000',
      isYouTube: false
    },
    {
      title: 'Market Update Video',
      videoId: '7uQPzidPfn4',
      category: 'Vertical',
      thumbnail: 'https://img.youtube.com/vi/7uQPzidPfn4/maxresdefault.jpg',
      isYouTube: true
    }
  ];

  const openVideo = (item) => {
    setSelectedVideo(item);
  };

  const closeVideo = () => {
    setSelectedVideo(null);
  };

  return (
    <section id="portfolio" className="section-padding bg-[#0f0f0f] border-t border-white/5" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="overline mb-5">Our Work</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white mb-6">
            Content that <span className="gold-gradient">commands attention.</span>
          </h2>
          <p className="text-lg md:text-xl text-[#a0a0a0]">
            Click any video to watch our latest editing projects.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {portfolioItems.map((item, index) => (
            <div
              key={index}
              onClick={() => openVideo(item)}
              data-testid={`portfolio-item-${index}`}
              className="group relative aspect-video rounded-lg overflow-hidden cursor-pointer bg-gray-900"
            >
              <img
                src={item.thumbnail}
                alt={item.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                onError={(e) => {
                  e.target.src = 'https://img.youtube.com/vi/' + item.videoId + '/hqdefault.jpg';
                }}
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-80 group-hover:opacity-100 transition-opacity duration-300"></div>
              
              {/* Play Button */}
              <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300">
                <div className="w-20 h-20 rounded-full bg-gradient-to-br from-yellow-500 to-yellow-600 flex items-center justify-center transform group-hover:scale-110 transition-transform shadow-2xl">
                  <Play size={36} className="text-black ml-1" fill="currentColor" />
                </div>
              </div>
              
              {/* Info */}
              <div className="absolute bottom-0 left-0 right-0 p-4 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                <div className="flex items-center justify-between mb-2">
                  <span className="inline-block px-3 py-1 bg-yellow-500/20 border border-yellow-500 rounded-full text-yellow-500 text-xs font-medium">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-white font-semibold text-lg">{item.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-[#a0a0a0] text-lg">
            Click any video to watch in full screen
          </p>
        </div>
      </div>

      {/* Video Modal with hidden controls */}
      {selectedVideo && (
        <div 
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/98 p-4"
          onClick={closeVideo}
        >
          <button
            onClick={closeVideo}
            data-testid="video-modal-close-button"
            className="absolute top-6 right-6 text-white hover:text-yellow-500 transition-colors z-50 bg-black/50 rounded-full p-3"
            aria-label="Close video"
          >
            <X size={32} />
          </button>
          
          <div 
            className="relative w-full max-w-6xl aspect-video video-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            {selectedVideo.isYouTube ? (
              <iframe
                src={`https://www.youtube.com/embed/${selectedVideo.videoId}?autoplay=1&modestbranding=1&rel=0`}
                title={selectedVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="w-full h-full rounded-lg shadow-2xl"
              ></iframe>
            ) : (
              <div className="relative w-full h-full">
                <iframe
                  src={`https://drive.google.com/file/d/${selectedVideo.videoId}/preview`}
                  title={selectedVideo.title}
                  allow="autoplay"
                  className="w-full h-full rounded-lg shadow-2xl"
                ></iframe>
                {/* Overlay to hide top-right controls */}
                <div className="absolute top-0 right-0 w-16 h-16 bg-black pointer-events-none z-10"></div>
              </div>
            )}
          </div>
        </div>
      )}
    </section>
  );
};

export default Portfolio;
